import { useAuth } from 'core/context/AuthContext/AuthContextProvider';

const firstValue = (...values: any[]) => values.find(value => {
  if (typeof value === 'string') return value.trim().length > 0;
  return value !== null && value !== undefined;
});

const initialsFor = (value: string) => value
  .trim()
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map(part => part[0]?.toUpperCase())
  .join('');

export const useLiveDemoSession = () => {
  const authData: any = useAuth();
  const userInfo = authData?.USER_INFO?.[0] || {};
  const staffRole = authData?.STAFF_ROLE || userInfo?.STAFF_ROLE || {};

  const counsellor = String(firstValue(
    authData?.NAME,
    authData?.USER_FIRSTNAME,
    userInfo?.NAME,
    userInfo?.USER_FIRSTNAME,
    authData?.USER_NAME,
    userInfo?.USER_NAME,
    'Counsellor',
  ));
  const role = String(firstValue(
    staffRole?.STAFF_ROLE_NAME,
    authData?.USER_ROLE_NAME,
    userInfo?.USER_ROLE_NAME,
    'Admissions team',
  ));
  const school = String(firstValue(
    authData?.INSTITUTE_NAME,
    userInfo?.INSTITUTE_NAME,
    authData?.BRANCH_NAME,
    userInfo?.BRANCH_NAME,
    'Your institution',
  ));
  const branchName = String(firstValue(authData?.BRANCH_NAME, userInfo?.BRANCH_NAME, ''));
  const branchAddress = String(firstValue(authData?.BRANCH_ADDRESS, userInfo?.BRANCH_ADDRESS, ''));
  const schoolSub = [branchName, branchAddress]
    .filter((value, index, values) => value && values.indexOf(value) === index)
    .join(' · ') || 'Admissions campus';

  return {
    counsellor,
    role,
    school,
    schoolSub,
    initials: initialsFor(counsellor) || 'U',
    badge: initialsFor(school) || 'SI',
  };
};
